import FourvenuesOrgLookupModal from "components/fourvenues/FourvenuesOrgLookupModal";
import React from "react";

export default function GlobalModals() {
  return (
    <>
      <FourvenuesOrgLookupModal />
    </>
  );
}
